import getActionName from '../../utils/getActionName';

const loadingReducer = (state = {}, action) => {
    const { type } = action;
    const actionName = getActionName(type);

    if (!actionName) {
        return {
            ...state
        };
    }

    if (type.endsWith('_REQUEST')) {
        return {
            ...state,
            [actionName]: {
                pending: true
            }
        };
    }

    if (type.endsWith('_SUCCESS')) {
        return {
            ...state,
            [actionName]: {
                pending: false
            }
        };
    }
    if (type.endsWith('_FAILURE')) {
        return {
            ...state,
            [actionName]: {
                pending: false
            }
        };
    }

    return {
        ...state
    };
};
export default loadingReducer;
